import React, { useContext, useCallback, useEffect, useState } from 'react';
import {
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@material-ui/core';
import { useStateValue } from 'context/store';
import { I18nContext } from 'translations';
import { getBulkEditHistory } from 'context/settings/users/actions';
import { INITIAL_PAGE } from 'utils/constants';
import Loading from 'components/Loading';
import BulkEditHistoryTable from 'components/Tables/Settings/Users/BulkEditHistoryTable';

const PER_PAGE = 20;

const ModalBulkEditHistory = ({ open, handleClose }) => {
  const { translate } = useContext(I18nContext);
  const [{ users: { bulkEditHistory, loadingBulkEditHistory } }, dispatch] = useStateValue();
  const [perPage] = useState(PER_PAGE);

  const getHistory = useCallback(async (page) => {
    getBulkEditHistory(dispatch, { page, per_page: perPage });
  }, [dispatch, perPage]);

  useEffect(() => {
    if (open) {
      getHistory(INITIAL_PAGE);
    }
  }, [open, getHistory]);

  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <DialogTitle className="text-center" disableTypography>
        <Typography variant="h5" color="primary">
          {translate('app.settings.users.bulkEditHistory.title')}
        </Typography>
      </DialogTitle>

      <DialogContent>
        {loadingBulkEditHistory && <Loading />}
        {bulkEditHistory && (
          <BulkEditHistoryTable
            data={bulkEditHistory}
            getHistory={getHistory}
            recordsPerPage={perPage}
          />
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>
          {translate('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalBulkEditHistory;
